import { ApiDealsPrice, ApiProductOffer } from 'data-source/types.wp'
import { priceFormat, wrapWithCurrency } from 'shared-code/format'
import { currencyMapper } from 'data-source/mappers/currencyMapper'

export function retailerButtonTitleMapper(
  retailer: string | undefined,
  input:
    | Pick<ApiDealsPrice, 'current_price' | 'currency' | 'is_free'>
    | Pick<ApiProductOffer, 'current_price' | 'currency'>
): string {
  const currency = currencyMapper(input.currency)
  let price: string | null = null

  if ('is_free' in input && input.is_free) {
    price = 'FREE'
  } else if (input.current_price) {
    price = wrapWithCurrency(priceFormat(input.current_price), currency)
  }

  if (retailer) {
    // temporally fix
    // @see: https://drewl.atlassian.net/browse/DT-3718
    return `See price at ${retailer}`
    // return `${price ? `${price} at ` : ''}${retailer}`
  }

  return price ?? 'Buy'
}
